export default "__VITE_ASSET__iSyd$bes__"